export const AiIcon = ({
  strokeColor = "var(--color-icon-obscure)",
  ...props
}: any) => (
  <svg {...props} width="24" height="24" viewBox="0 0 24 24" fill="none">
    <g id="ai-assistant">
      {/* Large sparkle */}
      <path
        id="Vector"
        d="M11.25 2.25L12.6 6.15C12.8 6.73 13.27 7.2 13.85 7.4L17.75 8.75L13.85 10.1C13.27 10.3 12.8 10.77 12.6 11.35L11.25 15.25L9.9 11.35C9.7 10.77 9.23 10.3 8.65 10.1L4.75 8.75L8.65 7.4C9.23 7.2 9.7 6.73 9.9 6.15L11.25 2.25Z"
        fill={strokeColor}
      />
      {/* Small sparkle */}
      <path
        id="Vector_2"
        d="M17.75 13.5L18.42 15.43C18.52 15.72 18.75 15.95 19.04 16.05L20.97 16.72L19.04 17.39C18.75 17.49 18.52 17.72 18.42 18.01L17.75 19.94L17.08 18.01C16.98 17.72 16.75 17.49 16.46 17.39L14.53 16.72L16.46 16.05C16.75 15.95 16.98 15.72 17.08 15.43L17.75 13.5Z"
        fill={strokeColor}
      />
      {/* Smallest sparkle */}
      <path
        id="Vector_3"
        d="M6.25 15.75L6.68 17C6.74 17.19 6.89 17.34 7.08 17.4L8.33 17.83L7.08 18.26C6.89 18.32 6.74 18.47 6.68 18.66L6.25 19.91L5.82 18.66C5.76 18.47 5.61 18.32 5.42 18.26L4.17 17.83L5.42 17.4C5.61 17.34 5.76 17.19 5.82 17L6.25 15.75Z"
        fill={strokeColor}
      />
    </g>
  </svg>
);

export default AiIcon;
